import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconExclamationMarkTriangle32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconExclamationMarkTriangle32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.638 5.77c-1.135-2.094-4.141-2.094-5.276 0L3.72 23.571C2.637 25.571 4.084 28 6.358 28h19.284c2.273 0 3.72-2.43 2.638-4.429zm-3.518.953a1 1 0 0 1 1.76 0l9.641 17.8a1 1 0 0 1-.88 1.477H6.359a1 1 0 0 1-.88-1.476zM15 18.5V12a1 1 0 0 1 2 0v6.5a1 1 0 1 1-2 0m2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconExclamationMarkTriangle32);
